
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'VaginalCancer_TNM',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/VaginalCancer_TNM.vue